export const pdfAutomaticWidth = (
    pageWidth: number,
    containerWidth: number,
): number => containerWidth / pageWidth;

export default {};
